import Service from '@/service/index.js';
import RegExpObj from '@/utils/regExp.js';
import Bus from '../../../transaction-pro/bus.js';
import { mapGetters } from 'vuex';
export default {
  components: {
  },
  props: ['projectInfo', 'projectSubType', 'type', 'assetsmassifs'],
  data() {
    const validateCertificateNo = (rule, value, callback) => {
      if (value && value.length < 18) {
        callback(new Error('请输入正确的统一社会信用代码或身份证号'));
      } else {
        callback();
      }
    };
    return {
      typeArr: [],
      landCategory: 1, // 农户承包地的类型为草地时候 隐藏地块类型
      // transferType: '', // 转让方式 整体交易
      massifs: [
        {
          massifName: '',
          area: null,
          type: '',
          price: null,
          toEast: '',
          toWest: '',
          toSouth: '',
          toNorth: '',
          attachment: '',
          originalContractor: '',
          certificateNo: ''
        }
      ],
      totalForm: {
        sumArea: null,
        sumPrice: null,
        currentPrice: null
      },
      rules: {
        massifName: [
          { required: true, message: '请输入地块名称', trigger: 'blur' }
        ],
        area: [
          { required: true, message: '请输入地块面积', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择地块类型', trigger: 'change' }
        ],
        price: [
          { required: true, message: '请输入地块转让总价格', trigger: 'blur' }
        ],
        toEast: [
          { required: true, message: '请输入东至', trigger: 'blur' }
        ],
        toWest: [
          { required: true, message: '请输入西至', trigger: 'blur' }
        ],
        toSouth: [
          { required: true, message: '请输入南至', trigger: 'blur' }
        ],
        toNorth: [
          { required: true, message: '请输入北至', trigger: 'blur' }
        ],
        attachment: [
          { required: true, message: '请输入地上附着物', trigger: 'blur' }
        ],
        certificateNo: [
          { required: false, validator: validateCertificateNo, trigger: 'blur' }
        ]
      },
      totalFormRules: {
        sumPrice: [
          { required: true, validator: this.sumPriceValidate, trigger: 'blur' }
        ],
        currentPrice: [
          { required: true, validator: this.sumPriceValidate, trigger: 'blur' }
        ]
      }
    };
  },
  computed: {
    ...mapGetters([
      'tradeType',
      'transferType'
    ]),
    pricePlaceHolder () {
      // 如果是协议交易
      if (Number(this.tradeType) === 2) {
        return '请填写以上地块发包期限内的流转成交总金额';
      } else {
        // 如果是整体交易
        if(Number(this.transferType) === 1) {
          return '请填写以上地块发包期限内的流转总金额';
        } else {
          return '填写地块信息后自动核算';
        }
      }
    }
  },
  watch: {
    projectInfo: {
      handler: function(){
        if(this.projectInfo && this.projectInfo.assetsInfo) {
          const assetsInfo = this.projectInfo && JSON.parse(this.projectInfo.assetsInfo);
          const arr = [];
          this.landCategory = this.projectInfo && this.projectInfo.landCategory;
          assetsInfo.forEach(item => {
            // const obj = JSON.parse(item);
            const obj = typeof item === 'string' ? JSON.parse(item) : item;
            Object.keys(obj).forEach((key) => {
              obj[key] = String(obj[key]);
            });
            arr.push(obj);
          });
          if (arr.length) {
            this.massifs = arr;
          }
        }
        if(this.projectInfo.sumPrice || this.projectInfo.sumArea) {
          Object.keys(this.totalForm).forEach((key) => {
            this.totalForm[key] = this.projectInfo && this.projectInfo[key] && String(this.projectInfo[key]);
          });
          this.$emit('landTotalForm', {sumPrice: this.totalForm.sumPrice, count: this.massifs.length});
        }
      },
      immediate: true // 初始化执行
    },
    assetsmassifs: {
      handler: function () {
        if (this.assetsmassifs.length > 0) {
          const arr = [];
          this.assetsmassifs.forEach(item => {
            arr.push({
              massifName: item.assetName,
              area: item.assetArea,
              type: '',
              price: null,
              toEast: item.toEast,
              toWest: item.toWest,
              toSouth: item.toSouth,
              toNorth: item.toNorth,
              attachment: '',
              originalContractor: '',
              certificateNo: '',
              assetId: item.assetId
            });
          });
          if (arr.length) {
            this.massifs = arr;
            let sumArea = 0;
            this.massifs.forEach(item => {
              sumArea += Number(item.area);
            });
            this.totalForm.sumArea = sumArea.toFixed(2);
          }
        }
      },
      immediate: true // 初始化执行
    }
  },
  created () {
    Service.getSelectList('PROJECT_TYPE').then(res => {
      if (res && res.code === '0') {
        let shList = res.data.find(item => item.code === '4');
        if(shList) {
          this.typeArr = shList.list;
        }
      }
    });
  },
  mounted() {
    Bus.$on('msg', (projectType, projectSubType, landCategory) => {
      if(landCategory) {
        this.landCategory = landCategory;
      }
    });
  },
  methods: {
    priceVali(rule, value, callback){
      if(value === '' || value === null){
        callback(new Error('请输入地块价格'));
      } else if(value < 1 || value > 9999999.99){
        callback(new Error('请输入0-10000000以内的数字'));
      } else {
        callback();
      }
    },
    areaVali(rule, value, callback){
      console.log(value, 'value');
      if(value === '' || value === null){
        callback(new Error('请输入地块面积'));
      } else if(value < 0 || value > 99999.99){
        callback(new Error('请输入0-100000以内的数字'));
      } else {
        callback();
      }
    },
    // 总金额校验
    sumPriceValidate(rule, value, callback){
      if(value === '' || value === null){
        callback(new Error(this.pricePlaceHolder));
      } else if(Number(value) < 1 || Number(value) > 9999999999) {
        callback(new Error('请输入1-9999999999以内的数字'));
      } else {
        callback();
      }
    },
    // 总金额校验
    // sumPriceValidate(rule, value, callback){
    //   if(value === '' || value === null){
    //     callback(new Error(this.pricePlaceHolder));
    //   } else if(this.projectSubType === '1'){
    //     if(Number(value) < 1 || Number(value) > 99999999) {
    //       callback(new Error('请输入0-99999999以内的数字'));
    //     } else {
    //       callback();
    //     }
    //   } else if(this.projectSubType === '2'){
    //     console.log(value, 'value', this.projectSubType, this.projectSubType === '2');
    //     if(Number(value) < 1 || Number(value) > 9999999999) {
    //       callback(new Error('请输入0-9999999999以内的数字'));
    //     } else {
    //       callback();
    //     }
    //   } else {
    //     callback();
    //   }
    // },
    // 当从别的页面切换过来时候 清空当前页面的值 如果说默认要展示当前页面 则不清空
    clear(){
      if( this.projectInfo.projectType === 1) return false;
      this.massifs = [
        {
          massifName: '',
          area: null,
          type: this.projectSubType,
          price: null,
          toEast: '',
          toWest: '',
          toSouth: '',
          toNorth: '',
          attachment: '',
          originalContractor: '',
          certificateNo: ''
        }
      ];
      this.totalForm = {
        sumArea: null,
        sumPrice: null,
        currentPrice: null
      };
      // 清空红色必填标示
      if(this.$refs['sihuangForm']) {
        this.$refs['sihuangForm'].resetFields();
      }
    },
    addLand () {
      this.massifs.push({
        massifName: '',
        area: null,
        type: this.projectSubType,
        price: null,
        toEast: '',
        toWest: '',
        toSouth: '',
        toNorth: '',
        attachment: '',
        originalContractor: '',
        certificateNo: ''
      });
    },
    deleteLand (index) {
      this.massifs.splice(index, 1);
      let sumArea = 0;
      this.massifs.forEach(item => {
        sumArea += Number(item.area);
      });
      this.totalForm.sumArea = sumArea.toFixed(2);

      let sumPrice = null;
      this.massifs.forEach(item => {
        sumPrice += Number(item.price);
      });
      this.totalForm.sumPrice = sumPrice.toFixed(2);
      this.$emit('landTotalForm', { sumPrice: this.totalForm.sumPrice, count: this.massifs.length});
    },
    changeArea (event, index) {
      if (!RegExpObj.num.test(this.massifs[index].area)) {
        return;
      }
      this.massifs[index].area = this.massifs[index].area && Number(this.massifs[index].area).toFixed(2);
      let num = 0;
      this.massifs.forEach(item => {
        num += Number(item.area);
      });
      this.totalForm.sumArea = num.toFixed(2);
    },
    changePrice (event, index) {
      if (!RegExpObj.num.test(this.massifs[index].price)) {
        return;
      }
      this.massifs[index].price = this.massifs[index].price && Number(this.massifs[index].price).toFixed(2);
      let num = null;
      this.massifs.forEach(item => {
        num += Number(item.price);
      });
      this.totalForm.sumPrice = num.toFixed(2);
      this.$emit('landTotalForm', {sumPrice: this.totalForm.sumPrice, count: this.massifs.length});
    },
    // 总金额改变
    changeSumPrice () {
      this.$emit('landTotalForm', {sumPrice: this.totalForm.sumPrice, count: this.massifs.length});
    },
    // 协议交易 成交金额
    changeCurrentPrice () {
      this.$emit('landTotalForm', {currentPrice: this.totalForm.currentPrice, count: this.massifs.length});
    },
    test() {
      // console.log(this.massifs, 'this.massifs');

      console.log(this.totalForm, '=========sihuangForm');
      return new Promise((resolve, reject) => {
        let num = 0;
        this.massifs.forEach((form, index) => {
          // 地块类型等于项目二级分类
          form.type = this.projectSubType;
          // 整体交易
          if (Number(this.transferType) === 1) {
            form.price = 0;
          }
          this.$refs[`sihuangForm${index}`][0].validate((valid) => {
            if (valid) {
              num ++;
            } else {
              reject();
            }
          });
        });
        if (num === this.massifs.length) {
          // 校验总金额
          this.$refs['totalForm'].validate((valid) => {
            if (valid) {
              // 协议交易时 总金额为0
              if (Number(this.tradeType) === 2) {
                this.totalForm.sumPrice = 0;
              }
              resolve({
                massifs: JSON.parse(JSON.stringify(this.massifs)),
                ...this.totalForm
              });
            } else {
              reject();
            }
          });
        } else {
          reject();
        }
      });
    }
  }
};
